
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 57 56","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.575 1.5L1.498 25.25 22.267 34 54.575 1.5z","fill":"none","stroke":"currentColor","stroke-width":"3"}}),_c('path',{attrs:{"d":"M54.574 1.5l-9.231 46.25L22.267 34 54.574 1.5zM22.267 34v20l8.076-15","fill":"none","stroke":"currentColor","stroke-width":"3"}})])
          )
        }
      }
    